import { Theme, useMediaQuery } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ItemCreation, ItemCreationSideSectionWrapper, ItemCreationWrapper } from '~/Components';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { Provider } from '~/Models/DTO/Provider.model';
import { ProviderSettingsSideSection, useProviderSettings } from './';

export const ProviderSettings = () => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

  const {
    listItems,
    onSave,
    initialValues,
    validate,
    error,
    isLoading,
    isSubmitDisabled,
    validationSchema,
    onValidationErrors,
  } = useProviderSettings();

  return (
    <PrivateLayout
      title={t('app.settings')}
      actionDisabled={isSubmitDisabled}
      actionName={t('app.save')}
      onActionTaken={onSave}
      hideBackButton={isDesktop}
    >
      <ItemCreationWrapper>
        <ItemCreation<Provider>
          listItems={listItems}
          headers={[]}
          onSave={onSave}
          initialValues={initialValues as Provider}
          validate={validate}
          networkError={error}
          isLoading={isLoading}
          validationSchema={validationSchema}
          onValidationErrors={onValidationErrors}
        />
        <ItemCreationSideSectionWrapper>
          <ProviderSettingsSideSection />
        </ItemCreationSideSectionWrapper>
      </ItemCreationWrapper>
    </PrivateLayout>
  );
};
